import Swiper from 'swiper';
import {
  Keyboard,
  Navigation,
  Pagination,
  Thumbs,
} from 'swiper/modules';

import gallery from './Gallery';

export default function smallGallery() {
  let smallGallerySwiper: Swiper | null = null;
  let smallGalleryThumbsSwiper: Swiper | null = null;

  function init() {
    if (smallGalleryThumbsSwiper === null
      && document.querySelector('.small-gallery-thumbs') !== null
    ) {
      smallGalleryThumbsSwiper = new Swiper('.small-gallery-thumbs', {
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        loop: true,
      });
    }
    if (smallGallerySwiper === null
      && document.querySelector('.small-gallery-slider') !== null
    ) {
      smallGallerySwiper = new Swiper('.small-gallery-slider', {
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        modules: [Navigation, Pagination, Keyboard, Thumbs],
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: smallGalleryThumbsSwiper,
        },
      });
    }
  }

  const parent = gallery();

  return {
    ...parent,
    init() {
      parent.init.call(this);
      init();
    },
  };
}
